import { createContext, useContext, useState } from 'react';
import PriceDialog from './PriceDialog';

const PriceDialogContext = createContext(null);

export const PriceDialogManager = ({ children }) => {
    const [priceDialog, setPriceDialog] = useState(null);

    return (
        <PriceDialogContext.Provider value={{ priceDialog, setPriceDialog }}>
            <PriceDialog dialog={priceDialog} setDialog={setPriceDialog} />
            {children}
        </PriceDialogContext.Provider>
    );
};

export const usePriceDialog = () => useContext(PriceDialogContext);
